import EditableContainer from '@v4/components/common/EditableContainer/EditableContainer'
import { Box, Grid } from '@material-ui/core'
import clsx from 'clsx'
import EditableHTML from '@v4/components/common/EditableHTML/EditableHTML'
import ActionButton from '@v4/components/common/Buttons/ActionButton'
import React, { memo } from 'react'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { useAdditionalText } from './AdditionalText.hooks'

const AdditionalText = props => {
	const [
		{
			className,
			classes,
			sm,
			md,

			text,
			textKey,
			textConfig,
			textEditable,

			buttonText,
			buttonTextKey,
			buttonTextConfig,
			buttonAction,
			buttonLink,
			buttonTextEditable,
		},
		{ handleTextClick, handleTextChange, handleButtonClick, handleButtonTextChange },
	] = useAdditionalText(props)

	return (
		<EditableContainer
			visible={!!text || !!buttonText}
			fieldConfig={textConfig}
			editable={textEditable}
			wrapper={() => (
				<div className={className}>
					<Grid container className={classes.grid}>
						<Grid
							item
							className={clsx(classes.gridItem, 'faq-additional-text-grid-item')}
							xs={12}
							sm={sm}
							md={md}
						>
							<EditableContainer
								visible={!!text}
								fieldConfig={textConfig}
								onAdd={handleTextChange}
								editable={textEditable}
							>
								<EditableHTML
									key={textKey}
									className={clsx(classes.text, 'faq-additional-text-block-title')}
									gutterBottom
									html={text}
									onClick={handleTextClick}
									editable={textEditable}
									onChange={handleTextChange}
								/>
							</EditableContainer>
							<EditableContainer
								visible={!!buttonText}
								fieldConfig={buttonTextConfig}
								onAdd={handleButtonTextChange}
								editable={buttonTextEditable}
								label="Button"
								wrapper={({ children }) => (
									<Box className={clsx(classes.buttonWrap, 'faq-additional-text-button-wrapper')}>
										{children}
									</Box>
								)}
							>
								<ActionButton
									key={buttonTextKey}
									action={buttonAction}
									href={buttonLink}
									className={clsx(classes.button, 'faq-additional-text-button')}
									onClick={handleButtonClick}
									editable={buttonTextEditable}
									onChange={handleButtonTextChange}
									rounded
								>
									{buttonText}
								</ActionButton>
							</EditableContainer>
						</Grid>
					</Grid>
				</div>
			)}
		/>
	)
}

AdditionalText.propTypes = {
	className: PropTypes.string,
	alignment: PropTypes.object,
	mobileAlignment: PropTypes.object,
	mobileButtonWidth: PropTypes.object,
	md: PropTypes.number,
	sm: PropTypes.number,

	mataText: PropTypes.instanceOf(PageMetaData),
	textMetaKey: PropTypes.string,

	metaButtonText: PropTypes.instanceOf(PageMetaData),
	buttonTextMetaKey: PropTypes.string,
	metaButtonAction: PropTypes.instanceOf(PageMetaData),
	buttonButtonLink: PropTypes.instanceOf(PageMetaData),
}
AdditionalText.defaultProps = {
	alignment: null,
	mobileAlignment: null,
	mobileButtonWidth: null,
	md: 12,
	sm: 12,
}

export default memo(AdditionalText)
